const MARKETING_KEY_PREFIX = 'blu_iphone_top_marketing_v1_'
const BANNER_SESSION_PREFIX = 'blu_iphone_top_banner_session_v1_'

export function marketingStorageKey (userId) {
  return `${MARKETING_KEY_PREFIX}${userId ?? 'anon'}`
}

export function getMarketingAckState (userId) {
  if (typeof localStorage === 'undefined') {
    return null
  }
  return localStorage.getItem(marketingStorageKey(userId))
}

export function setMarketingAckState (userId, value) {
  if (typeof localStorage === 'undefined' || !userId) {
    return
  }
  localStorage.setItem(marketingStorageKey(userId), value)
}

export function bannerSessionDismissKey (userId) {
  return `${BANNER_SESSION_PREFIX}${userId ?? 'anon'}`
}

export function isBannerDismissedThisSession (userId) {
  if (typeof sessionStorage === 'undefined') {
    return false
  }
  return sessionStorage.getItem(bannerSessionDismissKey(userId)) === '1'
}

export function dismissBannerForSession (userId) {
  if (typeof sessionStorage === 'undefined' || !userId) {
    return
  }
  sessionStorage.setItem(bannerSessionDismissKey(userId), '1')
}
